import {
   SET_LAYOUT_FILE,
   SET_LAYOUT_FOLDER,
   SET_DISPALY_LAST_MODIFIED,
   SET_DYSPLAY_OWNER,
   SET_SORT_SEFAULT,
   UPDATE_ERROR_CONNECT
} from '../constants';

export const updateConnect = (showBtn) => (dispatch) => {
    dispatch({
        type: 'UPDATE_CONNECT',
        payload: showBtn
    })
} 

export const updateErrorConnect = (showError) => (dispatch) => {
    dispatch({
        type: UPDATE_ERROR_CONNECT,
        payload: showError
    })
} 

export const setLayoutFile = (layoutFile) => (dispatch) => {
    dispatch({
        type: SET_LAYOUT_FILE,
        payload: layoutFile
    })
};

export const setLayoutFolder = (layoutFolder) => (dispatch) => {
    dispatch({
        type: SET_LAYOUT_FOLDER,
        payload: layoutFolder
    })
};

export const setDisplayLastModified = (displayLastModified) => (dispatch) => {
    dispatch({
        type: SET_DISPALY_LAST_MODIFIED,
        payload: displayLastModified
    })
};

export const setDisplayOwner = (displayOwner) => (dispatch) => {
    dispatch({
        type: SET_DYSPLAY_OWNER,
        payload: displayOwner
    })
};

export const setSortDefault = (sortDefault) => (dispatch) => {
    dispatch({
        type: SET_SORT_SEFAULT,
        payload: sortDefault
    })
};



// WEBPACK FOOTER //
// ./src/actions/updateConnectActions.js